import React, { useState, useEffect } from 'react';
import TextInputDuoList from '../TextInputDuoList';
import { useTranslation } from '../../context/TranslationContext';
import debug from '@commons-shared/debug';
import { config } from '../../config/environment';

const ShortcutsTab = () => {
  const { t } = useTranslation();
  
  // Initialiser l'état avec les données du localStorage si disponibles
  const [shortcuts, setShortcuts] = useState(() => {
    const savedShortcuts = localStorage.getItem('bel_shortcuts');
    if (savedShortcuts) {
      try {
        const parsed = JSON.parse(savedShortcuts);
        return parsed.shortcuts || [];
      } catch (error) {
        debug.error(config, 'Erreur lors du chargement initial des raccourcis depuis localStorage', error);
        return [];
      }
    }
    return [];
  });
  
  const [isLoading, setIsLoading] = useState(false);

  // Fonction pour charger les données depuis localStorage
  const loadFromLocalStorage = () => {
    setIsLoading(true);
    const savedShortcuts = localStorage.getItem('bel_shortcuts');
    if (savedShortcuts) {
      try {
        const parsed = JSON.parse(savedShortcuts);
        if (parsed.shortcuts) {
          setShortcuts(parsed.shortcuts);
        }
      } catch (error) {
        debug.error(config, 'Erreur lors du chargement des raccourcis depuis localStorage', error);
      }
    }
    setIsLoading(false);
  };

  // Charger les données au montage du composant
  useEffect(() => {
    loadFromLocalStorage();
  }, []);

  // Écouter les changements du localStorage (pour l'import de configuration)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'bel_shortcuts') {
        loadFromLocalStorage();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Fonction pour sauvegarder dans localStorage
  const saveToLocalStorage = (shortcutsData) => {
    const shortcutsFormatData = {
      shortcuts: shortcutsData,
      lastUpdated: new Date().toISOString()
    };
    
    try {
      localStorage.setItem('bel_shortcuts', JSON.stringify(shortcutsFormatData));
      debug.success(config, 'Raccourcis sauvegardés dans localStorage', shortcutsFormatData);
    } catch (error) {
      debug.error(config, 'Erreur lors de la sauvegarde dans localStorage', error);
    }
  };

  const handleShortcutsChange = (data) => {
    if (!isLoading) {
      setShortcuts(data);
      saveToLocalStorage(data);
      debug.log(config, 'Shortcuts changed', data);
    }
  };

  return (
    <div className="wa-text-input-duo-list wa-text-input-duo-list--compact">
      {/* Texte explicatif */}
      <div className="wa-text-input-duo-list--bordered" style={{
        backgroundColor: 'var(--color-primary-light)',
        borderColor: 'var(--color-primary)',
        padding: 'var(--spacing-lg)',
        borderRadius: 'var(--radius-md)'
      }}>
        <p style={{ color: 'var(--color-primary)', fontSize: '0.875rem', margin: 0 }}>
          {t('BBCODE_FORMAT_FOR_SHORTCUT_TAGS', 'BBCode format for shortcut tags')}
        </p>
      </div>

      {/* TextInputDuoList pour les raccourcis */}
      <TextInputDuoList
        key={`shortcuts-${shortcuts.length}-${JSON.stringify(shortcuts).substring(0, 50)}`}
        title=""
        initialCount={1}
        allowAdd={true}
        numbering={true}
        label1="@"
        label2="BBCode"
        placeholder1="R2"
        placeholder2="[roll:1d20$1]"
        radius="md"
        bordered={true}
        initialData={shortcuts}
        onChange={handleShortcutsChange}
      />

      {/* Texte explicatif pour la syntaxe */}
      <div className="wa-text-input-duo-list--bordered" style={{
        backgroundColor: 'var(--bg-tertiary)',
        borderColor: 'var(--border-light)',
        padding: 'var(--spacing-lg)',
        borderRadius: 'var(--radius-md)'
      }}>
        <p style={{ color: 'var(--text-primary)', fontSize: '0.875rem', margin: 0 }}>
          <strong>{t('TAG_SYNTAX', 'Tag syntax')} :</strong> @TAGNAME TEXT@<br />
          <span style={{ color: 'var(--text-secondary)' }}>
            ({t('SPACE_BETWEEN_TAGNAME_TEXT_OPTIONAL', 'space between TAGNAME and TEXT is optionnal')})
          </span>
        </p>
      </div>
    </div>
  );
};

export default ShortcutsTab;
